import React from "react";
import PageWrapper from "./common.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import RdCaqhTable from "../../components/report/RdCaqhTable";

const RdCaqhReport = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.report"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.provider_caqh_report"
          }
        ]}
      />
      <div className="user-tbl">
        <RdCaqhTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.auth
  };
};

export default connect(mapStateToProps, null)(RdCaqhReport);
